import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  primary: "#0760ad",
  primaryLight: "#098a48",
  secondary: "#118a94",
  white: "#FFFFFF"
};

const DEFAULT_DATA = {
  heroSection: {
    title: "Our Services & Facilities",
    subtitle: "Comprehensive care designed for your wellbeing at every stage of life",
    backgroundGradient: "from-[#0760ad] to-[#098a48]",
    image: ""
  },
  descriptionSection: {
    text: "WarmWellness Center offers a complete range of services and facilities to support your health journey. From our modern hospitals to specialized clinics and diagnostic centers, we provide integrated care with compassion. Our team of dedicated healthcare professionals is committed to delivering personalized treatment and ensuring you receive the attention you deserve."
  }
};

const ServicesHero = ({ isAdmin = false, onEdit }) => {
  const [servicesData, setServicesData] = useState(DEFAULT_DATA);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchServicesData = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/services/hero/`);
        if (response.ok) {
          const data = await response.json();
          setServicesData(data);
        } else {
          console.error('Failed to fetch services hero data');
        }
      } catch (error) {
        console.error('Error fetching services hero data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchServicesData();
  }, []);

  if (isLoading) {
    return (
      <div className="relative overflow-hidden bg-gray-200 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <span className="loading loading-spinner loading-lg"></span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`relative overflow-hidden bg-gradient-to-r ${servicesData.heroSection?.backgroundGradient || DEFAULT_DATA.heroSection.backgroundGradient} py-20 px-4 sm:px-6 lg:px-8`}>
        {servicesData.heroSection?.image && (
          <div className="absolute inset-0">
            <img 
              src={servicesData.heroSection.image} 
              alt="Services background" 
              className="w-full h-full object-cover opacity-20"
            />
          </div>
        )}
        <div className="max-w-7xl mx-auto text-center relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {servicesData.heroSection?.title || DEFAULT_DATA.heroSection.title}
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              {servicesData.heroSection?.subtitle || DEFAULT_DATA.heroSection.subtitle}
            </p>
          </motion.div>
        </div>
      </div>

      <div className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-lg text-gray-700 leading-relaxed">
            {servicesData.descriptionSection?.text || DEFAULT_DATA.descriptionSection.text}
          </p>
          {isAdmin && (
            <button 
              onClick={onEdit}
              className="btn btn-primary mt-8"
            >
              Edit Services Hero
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ServicesHero;